export function formatCount(n: number): string {
  if (n >= 10000) {
    const w = n / 10000;
    return `${w >= 10 ? Math.round(w) : w.toFixed(1)}万`;
  }
  return String(n);
}